import { ActionType } from "react-table";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { AncillaryCost } from "../../../../../Component/Model/Dto/WSP/AncillaryCost";
import { TableColumn } from "../../../../../Component/Model/Table/Table";
import { CurrencyFormatter } from "../../../../../Helpers/CurrencyFormatter";
import { Typography } from "@mui/material";

interface AncillaryCostRows {
    id?: number,
    description: string;
    cost: string;
    attendee: JSX.Element;
    actions: ActionType[];
}

interface AncillaryCostTable {
    columns: Array<TableColumn>;
    rows: Array<AncillaryCostRows>;
}

export function AncillaryCostsTableColumn(dataObject: AncillaryCost[], handleEdit: (ancillaryCost: AncillaryCost) => void, handleDelete: (id: number, description: string) => void, openAssociateAttendeeModal: (ancillaryCost: AncillaryCost) => void): AncillaryCostTable {
    const columns = [
        { Header: 'Description', accessor: 'description', id: 'description', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: false },
        
        { Header: 'Attendees', accessor: 'attendee', id: 'attendee', Cell: ({ value }: any) => value , disableSortBy: true },
        { Header: 'Cost (excl. VAT)', accessor: 'cost', id: 'cost', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: false, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: AncillaryCost, index: number) => ({
            id: item.id,
            description: item.description,
            cost: CurrencyFormatter(parseFloat(item.cost)),
            attendee:                  
                (<Typography
                variant="caption" fontWeight='regular' color="#007bff"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    openAssociateAttendeeModal(item);
                }}
            >
                {item.attendee}
            </Typography>) ,
            actions: [
                {
                    type: 'Edit',
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        handleEdit(item);
                        
                    },
                    icon: {
                        color: 'info',
                        name: 'edit',
                    }
                },
                {
                    type: 'Delete',
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        handleDelete(item.id!, item.description);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
